<template>
  <tr>
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id_subscriber"
             :value="entity.id_subscriber"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id_subscriber"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Jméno a příjmení' | translate" class="first_data">
      <strong>{{ entity.subscriber_name }}</strong></td>
    <td :data-th="'ID odběratele' | translate">{{ entity.id_subscriber }}</td>
    <td :data-th="'Název operátora' | translate">{{ entity.operator_name }}</td>
    <td :data-th="'Přečteno' | translate"><img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"
                                               v-if="entity.read"/></td>
    <td :data-th="'Smazáno' | translate"><img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"
                                              v-if="entity.deleted"/></td>
    <td :data-th="'Notifikace skryta' | translate"><img class="is_set" src="../../../../assets/images/is-set.svg" alt="Ano"
                                              v-if="entity.notification_hidden"/></td>
    <td :data-th="'Datum přečtení' | translate" v-html="$_date_formatFull(entity.date_read)"></td>
    <td :data-th="'Další informace' | translate" class="last_data">
          <span class="dotted more_info">
													<span class="help_popup">
                            <div v-if="entity.read"><strong><translate>Přečteno na id:</translate></strong> {{ entity.id_read_by_device }}<br></div>
                            <div v-if="entity.read_by_device_name"><strong><translate>Přečteno na:</translate></strong> {{ entity.read_by_device_name }}<br></div>
                            <div v-if="entity.notification_hidden"><strong><translate>Notifikace skryta na id:</translate></strong> {{ entity.id_notification_hidden_by_device }}<br></div>
                            <div v-if="entity.notification_hidden_by_device_name"><strong><translate>Notifikace skryta na:</translate></strong> {{ entity.notification_hidden_by_device_name }}<br></div>
                            <div v-if="entity.deleted"><strong><translate>Smazáno na:</translate></strong> {{ entity.id_deleted_by_device }}<br></div>
                            <div v-if="entity.deleted"><strong><translate>Smazáno:</translate></strong> {{ $_date_formatFull(entity.date_deleted, false) }} </div>
                            <div><strong><translate>Kritérium pro zaslání:</translate></strong> {{ entity.added_by }}<br></div>
													</span>
          </span>
    </td>
    <td></td>
  </tr>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "RecipientRow",
  data() {
    return {
      moduleName: 'messages',
    }
  },
  props: {
    entity: Object
  },
  mixins: [userSettings, rowActions],
  computed: {},
  methods: {
    // onChange: function (e) {
    // 	this.$emit('input', e)
    // },
    // goToDetail(e, id) {
    // 	this.$router.push({name: this.detailPageRouteName, params: {id: id}})
    // },
    // emitUpdatePackage(params) {
    // 	this.$emit('updatePackage', {'id': String(this.messageItem.id), 'params': params})
    // },
    emitDeleteRecipient() {
      this.$emit('deleteRecipient', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/recipients/RecipientRow.vue